import React, { useState, useEffect } from 'react';
import { Button, Space, Avatar, Dropdown, Menu, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSiteConfig } from '../../contexts/SiteConfigContext';
import api from '../../services/api';
import './PublicHeader.css';

interface PublicHeaderProps {
  currentPage?: string; // 当前页面标识，用于高亮对应菜单项
}

const PublicHeader: React.FC<PublicHeaderProps> = ({ currentPage = '' }) => {
  const navigate = useNavigate();
  const { user, logout, loading: authLoading } = useAuth();
  const { siteConfig, loading: configLoading } = useSiteConfig();
  const [gameTypes, setGameTypes] = useState<any[]>([]);
  const [displayedGames, setDisplayedGames] = useState(8);
  const [allGameTypes, setAllGameTypes] = useState<any[]>([]);

  // 获取游戏类型
  useEffect(() => {
    const fetchGameTypes = async () => {
      try {
        const response = await api.get('/games/types');
        console.log('获取到的游戏类型数据:', response.data);
        setAllGameTypes(response.data);
        setGameTypes(response.data.slice(0, displayedGames));
      } catch (error) {
        console.error('获取游戏类型失败:', error);
      }
    };
    fetchGameTypes();
  }, []);

  // 创建游戏类型下拉菜单
  console.log('当前gameTypes状态:', gameTypes, '是否为数组:', Array.isArray(gameTypes));
  
  const gameTypesMenu = (
    <Menu
      style={{
        background: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(15px)',
        border: '1px solid rgba(102, 126, 234, 0.3)',
        borderRadius: '12px',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.4)',
        padding: '8px 0',
        minWidth: '280px'
      }}
    >
      {Array.isArray(gameTypes) && gameTypes.length > 0 ? (
        <>
          {gameTypes.slice(0, 8).map(game => (
            <Menu.Item 
              key={game.id}
              style={{
                color: 'white',
                padding: '12px 16px',
                borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                margin: '0 8px',
                borderRadius: '8px',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate(`/game/${game.id}`)}
              onMouseEnter={(e) => {
                const target = e.domEvent.currentTarget as HTMLElement;
                target.style.background = 'rgba(102, 126, 234, 0.15)';
                target.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                const target = e.domEvent.currentTarget as HTMLElement;
                target.style.background = 'transparent';
                target.style.transform = 'translateX(0)';
              }}
            >
              <div className="flex items-center space-x-3">
                <Image
                  src={game.icon || '/images/game-icons/placeholder_184x69.jpg'}
                  alt={game.display_name}
                  width={74}
                  height={28}
                  style={{ objectFit: 'cover', borderRadius: '4px' }}
                  fallback="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCA0MCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjE2IiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjIwIiB5PSI4IiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iOCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkdhbWU8L3RleHQ+Cjwvc3ZnPg=="
                  preview={false}
                />
                <div className="flex flex-col">
                  <span 
                    className="font-medium" 
                    style={{ 
                      fontSize: '14px',
                      background: 'linear-gradient(135deg, var(--primary-color, #1890ff) 0%, var(--secondary-color, #722ed1) 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}
                  >
                    {game.display_name}
                  </span>
                  <div className="flex items-center space-x-2 text-xs" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
                    {game.is_steam_game && <span style={{ color: '#3b82f6' }}>[Steam]</span>}
                    {game.supports_mods && <span style={{ color: '#10b981' }}>[MOD]</span>}
                  </div>
                </div>
              </div>
            </Menu.Item>
          ))}
          {allGameTypes.length > displayedGames && (
            <Menu.Item 
              key="more"
              style={{
                color: 'rgba(102, 126, 234, 0.8)',
                padding: '12px 16px',
                textAlign: 'center',
                fontSize: '12px',
                margin: '0 8px',
                borderRadius: '8px',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                marginTop: '8px'
              }}
              onClick={() => {
                const newDisplayed = Math.min(displayedGames + 8, allGameTypes.length);
                setDisplayedGames(newDisplayed);
                setGameTypes(allGameTypes.slice(0, newDisplayed));
              }}
            >
              查看更多游戏类型... ({allGameTypes.length - displayedGames} 个剩余)
            </Menu.Item>
          )}
        </>
      ) : (
        <Menu.Item 
          key="loading"
          style={{
            color: 'rgba(255, 255, 255, 0.6)',
            padding: '12px 16px',
            textAlign: 'center',
            fontSize: '12px'
          }}
        >
          加载中...
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <nav className="public-header">
      <div className="nav-container">
        <div className="nav-logo">
          {!configLoading && siteConfig?.logo_url && (
            <img src={siteConfig.logo_url} alt="Logo" className="logo-img" />
          )}
          {!configLoading && siteConfig?.site_name && (
            <span className="logo-text">{siteConfig.site_name}</span>
          )}
        </div>
        
        <div className="nav-menu">
          <Button 
            type="text" 
            className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
            onClick={() => navigate('/')}
          >
            首页
          </Button>
          <Button 
            type="text" 
            className={`nav-link ${currentPage === 'pricing' ? 'active' : ''}`}
            onClick={() => navigate('/pricing')}
          >
            价格表
          </Button>
          <Dropdown 
            overlay={gameTypesMenu} 
            trigger={['hover']}
            placement="bottomLeft"
            overlayStyle={{ zIndex: 1050 }}
          >
            <Button 
              type="text" 
              className="nav-link"
              style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
            >
              支持的游戏
              <span style={{ fontSize: '12px' }}>▼</span>
            </Button>
          </Dropdown>
          <Button 
            type="text" 
            className="nav-link"
            onClick={() => navigate('/servers/create')}
          >
            创建服务器
          </Button>
        </div>
        
        <div className="nav-actions">
          {authLoading ? (
            <Space>
              <span style={{ color: 'rgba(255, 255, 255, 0.6)' }}>加载中...</span>
            </Space>
          ) : user ? (
            <Space>
              <Avatar size="small" style={{ backgroundColor: 'var(--primary-color)' }}>
                {user.username.charAt(0).toUpperCase()}
              </Avatar>
              <span style={{ color: 'white', fontWeight: 500 }}>{user.username}</span>
              <Button 
                type="primary" 
                size="small"
                onClick={() => navigate('/dashboard')}
              >
                控制台
              </Button>
              <Button 
                type="default" 
                size="small"
                onClick={logout}
              >
                退出
              </Button>
            </Space>
          ) : (
            <Space>
              <Button 
                type="default" 
                size="small"
                onClick={() => navigate('/login')}
              >
                登录
              </Button>
              <Button 
                type="primary" 
                size="small"
                onClick={() => navigate('/register')}
              >
                注册
              </Button>
            </Space>
          )}
        </div>
      </div>
    </nav>
  );
};

export default PublicHeader;